import { CommentType } from './schemas';
export const CommentTypeDisplay = new Map([
    [CommentType.ACTIVITY, 'Activity'],
    [CommentType.EVENT, 'Event'],
    [CommentType.FEMU_R_003, 'FEMU-R-003'],
    [CommentType.GENERAL, 'General'] // aka "Notes"
]);
